import React, { useState, PropsWithChildren, useContext } from 'react';
import { AuthContext } from './AuthContext';
import useResourceLoader from '../util/useResourceLoader';
import UWEEntityApi from '../api/UWEEntityApi';
import dayjs from 'dayjs';

type TOcifExtensionsContext = {
  extensionsThisYear: number | undefined;
  loading: boolean | undefined;
  error: Error | undefined;
  setFetchExtensions: (value: boolean, refresh?: boolean) => void;
};

type OcifExtensionsContextProps = PropsWithChildren & {};

const OcifExtensionsContext = React.createContext<TOcifExtensionsContext | undefined>(undefined);

export function OcifExtensionsContextProvider({ children }: OcifExtensionsContextProps) {
  const auth = useContext(AuthContext);
  const orgId = auth?.user?.user?.actualOrganizationalUnitId;

  const [fetchExtensions, _setFetchExtensions] = useState<boolean>(false);

  const [extensionsThisYear, loading = true, error] = useResourceLoader(async () => {
    if (!fetchExtensions || !orgId) return useResourceLoader.DoNotSet;

    const result = await UWEEntityApi.getWorkTray({
      resource: `uwe-entities/Extension/list/${orgId}`,
      offset: 0,
      size: 10000,
      sortBy: 'id',
      after: dayjs()
        .startOf('year')
        .format('YYYY-MM-DDTHH:mm:ss[Z]'),
    });

    _setFetchExtensions(false);

    return result?.items.length ?? 0;
  }, [fetchExtensions, orgId]);

  const setFetchExtensions = (value: boolean, refresh: boolean = false) => {
    if (loading) return;
    if (extensionsThisYear != null && !refresh) return;
    _setFetchExtensions(value);
  };

  return (
    <OcifExtensionsContext.Provider value={{ extensionsThisYear, loading, error, setFetchExtensions }}>{children}</OcifExtensionsContext.Provider>
  );
}

export default OcifExtensionsContext;
